<template>
  <a-drawer
    :title="$t('switchAccount')"
    :visible="sVisible"
    width="444"
    placement="right"
    @close="onClose"
  >
    <div class="user-center__content">
      <div
        v-if="userInfo.relationUserList && userInfo.relationUserList.length"
        class="user-center__moreAccount"
      >
        <iw-scrollbar
          keep-show
          :wrap-style="
            'min-width: 200px; max-height: calc(100vh - 88px); padding-right: 24px;'
          "
        >
          <ul>
            <li
              v-for="item in userInfo.relationUserList"
              :key="item.userId"
              :class="{
                'is-expire': moment(item.actvToYmd).isBefore(moment())
              }"
              class="user-center__account-item"
            >
              <div class="user-center__account-title">
                <span>{{ item.userNm }}</span>
                <a v-if="moment(item.actvToYmd).isBefore(moment())">
                  {{ $t("expired") }}
                </a>
                <a v-else-if="item.userSt === '0' || item.userSt === '4'">
                  {{ item.userStNm }}
                </a>
                <a v-else-if="item.userId === userInfo.userId">{{
                  $t("currentAccount")
                }}</a>
                <a v-else class="switch" @click="switchAccount(item)">
                  {{ $t("switchToThisAccount") }}
                </a>
              </div>
              <div class="user-center__account-realName">
                {{
                  [item.userRealNm, item.compNm].filter(val => val).join(" / ")
                }}
              </div>
              <div class="user-center__account-expireTime">
                <span>
                  {{
                    [
                      item.actvFrYmd &&
                        moment(item.actvFrYmd, "YYYYMMDD").format("YYYY/MM/DD"),
                      item.actvToYmd &&
                        moment(item.actvToYmd, "YYYYMMDD").format("YYYY/MM/DD")
                    ]
                      .filter(item => item)
                      .join("~")
                  }}
                </span>
                <span>{{ item.userDivNm }}</span>
                <a-tag :color="`${item.userSt === '1' ? 'green' : ''}`">
                  {{ item.userStNm }}
                </a-tag>
              </div>
            </li>
          </ul>
        </iw-scrollbar>
      </div>
    </div>
  </a-drawer>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
import actions from "@/utils/actions";
const channels = {
  XIAOCHENGXU: 2,
  PC: 1
};
export default {
  props: {
    visible: {
      type: Boolean
    }
  },
  data() {
    return {
      sVisible: this.visible
    };
  },
  computed: {
    ...mapState({
      userInfo: state => state.user.userInfo
    })
  },
  watch: {
    visible(val) {
      this.sVisible = val;
    }
  },
  methods: {
    moment,
    onClose() {
      this.sVisible = false;
      this.$emit("close", this.sVisible);
    },
    switchAccount(item) {
      this.$store
        .dispatch("user/switchAccount", {
          channel: channels["PC"],
          userId: item.userId
        })
        .then(() => {
          this.sVisible = false
          this.$message({
            type: "success",
            message: "切换账号成功",
            customClass: "message-success"
          });
          // window.location.href = "/"; 此代码不会调用微应用的 unmount()方法, 改用下面方法
          // console.log(1111111, this.$router, this.$route)
          if (this.$route.name === 'Dashboard') {
            window.location.href = "/"
          } else {
            // 在微应用界面切换机构调用下面方法才会线性调用微应用的 unmount()方法
            this.$router.replace({ path: '/' })
          }
          // this.$store.dispatch("user/getUserInfo");
          // // 更新全局token
          // actions.setGlobalState({
          //   token: this.token,
          //   time: moment().format("yyyy.MM.DD HH:mm:ss")
          // });
          actions.setGlobalState({
            switchAccount: item.userId
          });
        });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/styles/_handle.scss";

.user-center__content {
  padding: 0;
  height: 100%;

  .user-center__moreAccount {
    font-size: 14px;
    .user-center__account-item {
      padding: 20px;
      background: #f7f8fa;
      margin-bottom: 24px;
      border-radius: 4px;
      &.is-expire {
        opacity: 0.5;
      }
      .user-center__account-title {
        font-size: 16px;
        a {
          font-size: 14px;
          float: right;
          cursor: default;
          &.switch {
            cursor: pointer;
            @include color("primary");
          }
        }
      }
      // .user-center__account-realName {
      // }
      .user-center__account-expireTime {
        color: #bcc0cc;
        display: flex;
        justify-content: space-between;
      }
    }
    > a {
      margin-top: 10px;
      display: inline-block;
      @include color("primary");
    }
  }
}
</style>
